"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageName = void 0;
__exportStar(require("../../../../lib/google/api/annotations_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/api/annotations_pb"), exports);
__exportStar(require("../../../../lib/google/api/field_behavior_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/api/field_behavior_pb"), exports);
__exportStar(require("../../../../lib/google/api/http_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/api/http_pb"), exports);
__exportStar(require("../../../../lib/google/api/httpbody_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/api/httpbody_pb"), exports);
__exportStar(require("../../../../lib/google/api/resource_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/api/resource_pb"), exports);
__exportStar(require("../../../../lib/google/api/visibility_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/api/visibility_pb"), exports);
exports.packageName = "google.api";
//# sourceMappingURL=index.js.map